const TTL_MS = 5 * 60 * 1e3;
let at = 0;
let ok = false;
let cachedForToken = "";
let cachedExtra = "";
function cacheKey(token, extra = "") {
    return `${String(token || "")}\u001e${String(extra || "")}`;
}
export function tokenCheckFresh(currentToken, extra = "") {
    if (!currentToken)
        return false;
    if (cacheKey(currentToken, extra) !== cacheKey(cachedForToken, cachedExtra))
        return false;
    return ok && Date.now() - at < TTL_MS;
}
export function setTokenCheckResult(success, token, extra = "") {
    at = Date.now();
    ok = !!success;
    cachedForToken = token || "";
    cachedExtra = extra || "";
}
export function clearTokenCheckCache() {
    ok = false;
    at = 0;
    cachedForToken = "";
    cachedExtra = "";
}
